module.exports = __webpack_public_path__ + "img/select2.f6ac1da9.svg";